import { Link } from '@infinex/ui/components';

import { useGasDialogConfig } from '../GasDialogDependenciesContext';

export function LegalInfo() {
  const { isPatron, networkCostsLegalUrl } = useGasDialogConfig();

  return (
    <span className="text-secondary text-center text-xs text-pretty">
      Infinex passes on network costs without additional fees.{' '}
      {isPatron
        ? `Patrons don't pay network costs for some transactions. `
        : ''}
      <Link
        href={networkCostsLegalUrl}
        target="_blank"
        className="hover:text-default underline"
      >
        Learn more
      </Link>
    </span>
  );
}
